import React from 'react'
import './styles.css'

const Details = () => {
	return (<>
		<div className='img-product-placeholder2'></div>
		<div className="info-placeholder">
			<div className='product-description-placeholder'></div>
			<div className='product-description-placeholder2'></div>
			<div className='product-description-placeholder'></div>
		</div>
		</>
	)
}

export default Details